import { gql } from '@apollo/client'

export const getUserProjectsQuery = gql`
    query getUserProjectsQuery(
        $limit: Int!
        $offset: Int
        $sort: CreatedAtSortKey
        $cursor: ENCODED_CURSOR
    ) {
        me {
            id
            projects(
                limit: $limit
                cursor: $cursor
                sort: $sort
                offset: $offset
            ) {
                totalCount
                items {
                    id
                    name
                    description
                    createdAt
                    createdBy {
                        displayName
                    }
                    updatedBy {
                        email
                    }
                }
            }
        }
    }
`

export const createProjectMutation = gql`
    mutation createProjectMutation($projectInput: ProjectInput!) {
        createProject(projectInput: $projectInput) {
            id
            name
            description
            createdAt
            updatedAt
        }
    }
`

export const isActiveUserEmailQuery = gql`
    query isActiveUserEmailQuery($email: String!) {
        isActiveUserEmail(email: $email)
    }
`

export const isEmployeeEmailQuery = gql`
    query isEmployeeEmailQuery($email: String!) {
        isEmployeeEmail(email: $email)
    }
`
